import { render, staticRenderFns } from "./printDSLKSales.vue?vue&type=template&id=1b681793&scoped=true&"
import script from "./printDSLKSales.vue?vue&type=script&lang=js&"
export * from "./printDSLKSales.vue?vue&type=script&lang=js&"
import style0 from "./printDSLKSales.vue?vue&type=style&index=0&id=1b681793&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b681793",
  null
  
)

component.options.__file = "printDSLKSales.vue"
export default component.exports